module.exports = __webpack_public_path__ + "img/winning-prize-logo.fe55bf03.png";